module.exports = __webpack_public_path__ + "static/media/log.528c8784.svg";